module.exports = __webpack_public_path__ + "static/media/flower.ec382311.mp3";